import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ProblemStoreEffects } from './effects';
import { problemReducer } from './reducer';
import { ProblemFacade } from './facade';
import { stateName } from './selectors';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature(stateName, problemReducer), EffectsModule.forFeature([ProblemStoreEffects])],
  exports: [],
  providers: [ProblemFacade],
  declarations: [],
})
export class ProblemStateModule {}
